import { useAuth } from '@entities/auth'
import type { ReactNode } from 'react'

export function AuthGate({
  children,
  fallback,
}: {
  readonly children: ReactNode
  readonly fallback: ReactNode
}) {
  const { isLoggedIn } = useAuth()

  return isLoggedIn ? children : fallback
}
